import events from "./events";
import provider from "./provider";

const KINDS = Object.freeze(Object.fromEntries([provider, events].map((kind) => [kind.name, kind])));

/** The names `<sp-finder kind>` accepts. */
export const FINDER_KIND_NAMES = Object.freeze(Object.keys(KINDS));

/** Returns the registered finder kind called `name`. Throws for a name no kind registers. */
export function getFinderKind(name) {
  const kind = KINDS[name];
  if (!kind) {
    throw new Error(`Unknown finder kind "${name}". Registered kinds: ${FINDER_KIND_NAMES.join(", ")}`);
  }
  return kind;
}
